(function () {
  'use strict';

  class BIReportCtrl {
    constructor(Keys, ServiceVfiltro, FactoryVfiltro, Authenticator, safetyService) {
      this.authenticator = Authenticator;
      this.serviceVfiltro = ServiceVfiltro;
      this.safetyService = safetyService;

      this.serviceVfiltro.init(FactoryVfiltro.get([
        {
          key: Keys.uo.name
        }
      ]))
      .then((filtro) => {
        this.vfiltroBackend = this.serviceVfiltro.getFiltroBackendNovo(filtro);

        this.safetyService.initialize().then(() => this.loadSafety());
      });
    }

    loadSafety() {
      this.authenticator.getUser().then(user => {
        const appName = 'safetyApp',
            componentPath = './BIReport',
            componentId = 'safety-bi-report',
            props = {
              user: user,
              uoId: this.vfiltroBackend.uo_permissao
            };

        this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
      });
    }
  }

  angular
    .module('biReport')
    .controller('BIReportCtrl', BIReportCtrl);
}());
